import { IDataTableColumn, FieldSet, useGridState } from "nsitools-react";
import * as React from "react";

import { CustomDataTable, ExportButton } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl, useSearchApiWithLanguageRefresh } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { PersonsDogsApi, PersonDogsGridDto, PersonDogsSearch } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { Link } from "react-router-dom";
import { Checkbox, ButtonGroup } from "@blueprintjs/core";
import styled from "styled-components";

export interface IPersonDogsPageProps {
  personId: number;
}

const StyledCheckbox = styled(Checkbox)`
  font-size: 10pt;
  top: 6px;
`;

export const PersonDogsPage: React.FunctionComponent<IPersonDogsPageProps> = ({ personId }) => {
  const [hideDead, sethideDead] = React.useState(true);
  const { currentLanguage } = useGlobalData();

  const api = useApiService(PersonsDogsApi);
  const { t } = useTl();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5],
    pageSize: 5,
  });

  const searchFunction = React.useCallback(
    (sObj?) => {
      const sobj = PersonDogsSearch.fromJS({
        ...sObj,
        personId: personId,
        hideDead: hideDead,
        languageId: currentLanguage.languageId,
      });
      setsobjState(sobj);
      return api.baseSearch(sobj);
    },
    [api, currentLanguage.languageId, hideDead, personId]
  );

  const { search, loading } = useSearchApiWithLanguageRefresh({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const toggleHideDead = React.useCallback(() => {
    sethideDead(!hideDead);
    search();
  }, [hideDead, search]);
  const [sObjState, setsobjState] = React.useState<any>();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.CompleteName),
        fieldName: "computedName",
        render: (row: PersonDogsGridDto) => (
          <Link target="_blank" to={`${ERoutes.dog}/${row.dogId}/detail/view`}>
            {row.computedName}
          </Link>
        ),
      },
      {
        header: () => t(ETLCodes.OwnerFrom),
        fieldName: "ownerFrom",
      },
      {
        header: () => t(ETLCodes.OwnerTo),
        fieldName: "ownerTo",
        render: (row: PersonDogsGridDto) =>
          `${
            row.ownerTo
              ? row.ownerTo.getFullYear() > 1
                ? `${row.ownerTo.getDay() < 10 ? "0" + row.ownerTo.getDay() : row.ownerTo.getDay()}-${
                    row.ownerTo.getMonth() < 10 ? "0" + row.ownerTo.getMonth() : row.ownerTo.getMonth()
                  }-${row.ownerTo.getFullYear()}`
                : ""
              : ""
          }`,
      },
      {
        header: () => t(ETLCodes.DeathDate),
        fieldName: "deathDate",
      },
    ],
    [t]
  );

  return (
    <FieldSet
      title={t(ETLCodes.Dogs)}
      rightElement={
        <ButtonGroup>
          <StyledCheckbox checked={hideDead} onClick={toggleHideDead} label={t(ETLCodes.HideDead)} />
          <ExportButton exportFunction={(sObj) => api.exportXlsFile(sObj)} sObj={sObjState} />
        </ButtonGroup>
      }
    >
      <CustomDataTable tableState={tableState} loading={loading} columns={columns} />
    </FieldSet>
  );
};
